import { routes as inpatientRoutes } from "./patient-list/routes";
import { routes as nursingNotesRoutes } from "./nursing-notes/routes";
import { routes as dailyReportRoutes } from "./daily-report/routes";
export const routes = [

    ...inpatientRoutes(),
    ...nursingNotesRoutes(),
    ...dailyReportRoutes(),
];
